import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
//@ts-expect-error
import ImmutablePropTypes from 'react-immutable-proptypes';
import Tabs from 'src/components/Tabs/Tabs';
import classNames from 'classnames';
import { Amount } from 'src_common/common/amount/Amount';
import {
    CountersComponentState,
    TabDataType,
} from 'src/components/CustomersBar/CustomerTab/CustomerSummaryTab/CountersComponent/CountersComponent.state';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
interface PropsType {
    customerId: number;
    currency: CurrencyType;
}

export const CountersComponent = observer('CountersComponent', ({ customerId, currency }: PropsType): JSX.Element => {
    const common = useCommon();
    const {
        config: { usePaymentFormForUniverse },
        precision,
    } = ConfigState.get(common);

    const [state] = useState(
        () => new CountersComponentState(common.trpcClient, precision, customerId, usePaymentFormForUniverse)
    );

    const lifeTimeClasses = classNames([
        'lifetime__value',
        {
            'lifetime__value--over': state.lifeTimeTotalPrecentage >= 0,
            'lifetime__value--under': state.lifeTimeTotalPrecentage < 0,
        },
    ]);

    const getTabContent = (tab: TabDataType): JSX.Element => {
        const labelName = tab.name;

        return (
            <table
                key={labelName}
                className='counters__table'
                //@ts-expect-error
                label={labelName}
            >
                <tbody>
                    {tab.data.counters.map((item) => {
                        const profitLossClasses = classNames([
                            'counters__table__precentage',
                            {
                                'counters__table__precentage--over': item.profit.isGreaterOrEqual(new Amount('0')),
                                'counters__table__precentage--under': item.profit.isLessThan(new Amount('0')),
                            },
                        ]);

                        return (
                            <tr key={item.name}>
                                <td>{`${item.name[0]?.toUpperCase()}${item.name.substring(1)}`}</td>
                                <td>
                                    <span className='counters__table__label'>Bets</span> {item.bets}
                                </td>
                                <td>
                                    <span className='counters__table__label'>Avg Stake</span>
                                    {item.turnover.div(item.bets).format(currency)}
                                </td>
                                <td>
                                    <span className='counters__table__label'>T/O</span>
                                    {item.turnover.format(currency)}
                                </td>
                                <td>
                                    <span className='counters__table__label'>P/L</span>
                                    {item.profit.format(currency)}
                                </td>
                                <td>
                                    <span className={profitLossClasses}>{item.percent} %</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    };

    return (
        <div>
            {state.counters.type === 'ready' && state.tabs.length !== 0 ? (
                <div>
                    <h3 className='lifetime__value--label'>Lifetime Value</h3>
                    <div className={lifeTimeClasses}>
                        <ul>
                            <li>
                                Turnover:
                                <span>{state.allTurnover.format(currency)}</span>
                            </li>
                            <li>
                                Profit/Loss:
                                <span>{state.allProfit.multiply(-1).format(currency)}</span>
                            </li>
                        </ul>
                        <div className='lifetime__value__percentage'>
                            {state.lifeTimeTotalPrecentage === 0 ? null : `${state.lifeTimeTotalPrecentage}%`}
                        </div>
                    </div>
                    <Tabs
                        tabsPlacement='left-vertical-menu'
                        className='tabs__horizontal tabs__customers-inner'
                    >
                        {state.tabs.map((tab) => getTabContent(tab))}
                    </Tabs>
                </div>
            ) : (
                <p className='profit-loss-unavailable'>Profit/Loss calculations are unavailable for this customer.</p>
            )}
        </div>
    );
});
